import { useSearchkit, useSearchkitVariables } from '@searchkit/client';
import React from 'react';
import FormikWrapper from '../../Form/FormikWrapper';
import Select from '../../Form/Select';
var useInitialValues = function useInitialValues(variables) {
  return {
    'sortBy': variables.sortBy
  };
};
var SearchSorting = function SearchSorting(_ref) {
  var _data$results, _data$results$summary, _data$results$summary2;
  var data = _ref.data,
    loading = _ref.loading;
  var api = useSearchkit();
  var variables = useSearchkitVariables();
  var initialValues = useInitialValues(variables);
  var options = (data === null || data === void 0 ? void 0 : (_data$results = data.results) === null || _data$results === void 0 ? void 0 : (_data$results$summary = _data$results.summary) === null || _data$results$summary === void 0 ? void 0 : (_data$results$summary2 = _data$results$summary.sortOptions) === null || _data$results$summary2 === void 0 ? void 0 : _data$results$summary2.map(function (sortOption) {
    return {
      value: sortOption.id,
      label: sortOption.label
    };
  })) || [];
  return /*#__PURE__*/React.createElement(FormikWrapper, {
    initialValues: initialValues
  }, /*#__PURE__*/React.createElement(Select, {
    fieldName: "sortBy",
    isClearable: false,
    isSearchable: false,
    options: options,
    selectedOption: options.filter(function (option) {
      return option.value === variables.sortBy;
    }),
    isLoading: loading,
    onChange: function onChange(value) {
      api.setSortBy(value);
      api.setPage({
        from: 0
      });
      api.search();
    }
  }));
};
export default SearchSorting;